import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import StripeDebug from './components/StripeDebug';

// Pages
import NewResearch from './pages/NewResearch';
import ResearchStatus from './pages/ResearchStatus';
import ReportsList from './pages/ReportsList';
import ReportView from './pages/ReportView';
import Login from './pages/Login';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';

// Contexts
import { AuthProvider } from './contexts/AuthContext';
import { StripeProvider } from './contexts/StripeContext';

function App() {
  return (
    <AuthProvider>
      <StripeProvider>
        <StripeDebug />
        <Router>
          <div>
            <Navigation />
            <main className="container">
              <Routes>
                <Route path="/login" element={<Login />} />
                
                {/* Protected Routes */}
                <Route element={<PrivateRoute />}>
                  <Route path="/" element={<NewResearch />} />
                  <Route path="/research/:id" element={<ResearchStatus />} />
                  <Route path="/reports" element={<ReportsList />} />
                  <Route path="/reports/:id" element={<ReportView />} />
                  
                  {/* Payment Routes */}
                  <Route path="/payment" element={<PaymentPage />} />
                  <Route path="/payment/success" element={<PaymentSuccess />} />
                  <Route path="/payment/cancel" element={<PaymentCancel />} />
                </Route>
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </StripeProvider>
    </AuthProvider>
  );
}

export default App;
